// extracted by mini-css-extract-plugin
export default {"modal":"PU-z","error":"QU-z","disabled":"RU-z","fields":"SU-z","errorMsg":"TU-z","footer":"UU-z","formContentWrapper":"VU-z","productImage":"WU-z","overlay":"XU-z"};